<template>
    <div id="imgBackground" align-center justify-center row fill-height>
        <v-layout align-center justify-center row fill-height>
            <v-container fluid
                         grid-list-xl>
                <v-card
                        class="mx-auto"
                        max-width="344"
                >

                    <v-card-title style="text-align: center !important;display: block">
                        <v-img style="height: 100px" src="../../assets/logo.png" contain></v-img>
                    </v-card-title>
                    <v-card-text>
                        <v-form v-model="valid" ref="formData" style="text-align: center">
                            <br/>
                            <v-text-field
                                style="margin-bottom: 10px;"
                                outlined
                                v-model="userDoc.username"
                                :rules="userNameRules"
                                :label="$t('userName')"
                                required
                                prepend-inner-icon="mdi-face"
                            ></v-text-field>
                            <v-text-field
                                outlined
                                v-model="userDoc.password"
                                :rules="passwordRules"
                                :label="$t('password')"
                                autocomplete
                                prepend-inner-icon="mdi-lock-outline"
                                required
                                :type="show ? 'text' : 'password'"
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="show = !show"
                            ></v-text-field>
                            <br>
                            <v-btn
                                block
                                large
                                @click="login"
                                class="primary"
                                v-shortkey="['enter']"
                                @shortkey="login"
                            >
                                {{ $t("login") }}
                            </v-btn>
                            <br>
                            <br>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-container>

        </v-layout>
    </div>
</template>
<script>
    import validatorMixin from "../../mixins/validatorMixin";
    import mainMixin from "../../mixins/mainMixin";
    import axios from "axios";
    import {provider} from "../../service/provider";

    export default {
        name: "Login",
        mixins: [validatorMixin, mainMixin],
        data() {
            return {
                valid: false,
                show: false,
                userDoc: {
                    username: "",
                    password: ""
                }
            };
        },
        methods: {
            login() {
                let vm = this;
                if (vm.$refs.formData.validate()) {
                    try {
                        return new Promise((resolve, reject) => {
                            let url = provider.baseURL + "/login";
                            axios
                                .post(url, {
                                    username: vm.userDoc.username,
                                    password: vm.userDoc.password,
                                    device_id: "fgyhu4567cfvghjdttyui4567ftgyh9rdfgh"
                                })
                                .then(
                                    res => {
                                        if (res.data.response.code === 200) {

                                            res.data.data.username=vm.my_encrypt(res.data.data.username);
                                            localStorage.token = res.data.token;
                                            localStorage.username = res.data.data.username;
                                            localStorage.password = vm.my_encrypt(vm.userDoc.password);
                                            localStorage.contact_id = res.data.data.contact_id;
                                            localStorage.type = res.data.data.type;
                                            localStorage.position = res.data.data.position;
                                            localStorage.profile = res.data.data.profile;
                                            localStorage.parent_id = res.data.data.parent_id;
                                            localStorage.full_name = res.data.data.full_name;
                                            localStorage.province_code = res.data.data.province_code || "";
                                            localStorage.id = res.data.data.id;
                                            localStorage.phone = vm.formatPhoneNumber(res.data.data.phone);
                                            vm.$store.state.userDoc = res.data.data;
                                            vm.$router.push({name: "home"});

                                            vm.$notify({
                                                title: "Success",
                                                message: vm.$t("loginSuccess"),
                                                type: "success",
                                                duration: 1000
                                            });
                                            resolve(res.data);
                                        } else {
                                            vm.$notify({
                                                title: "Error",
                                                message: vm.$t("loginFail"),
                                                type: "error",
                                                duration: 2000
                                            });
                                        }
                                    },
                                    error => {
                                        console.log(error.message);
                                        reject(error);
                                        vm.$notify({
                                            title: "Error",
                                            message: error.message,
                                            type: "error",
                                            duration: 2000
                                        });
                                    }
                                );
                        });
                    } catch (err) {
                        vm.$notify({
                            title: "Error",
                            message: err.message,
                            type: "error",
                            duration: 2000
                        });
                    }
                }
            }
        },
        created() {
            if (this.$router.history.current.name !== "login") {
                this.$router.push({name: "login"});
            }
        }
    };
</script>
<style scoped>
    #imgBackground {
        background-image: url("../../assets/background.jpg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 100%;
    }
</style>
